// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"153":"755c728c","224":"b0099b66","249":"55aed32f","335":"9239a2b8","366":"20b439e4","468":"f4024212","488":"c9a5b78f","599":"2a1b80e0","626":"f6af9bf6","637":"df28345a","689":"0d815296","775":"507c07cb","796":"b5020461","852":"6d88376a","854":"4c9529d9","918":"3a531651"}[chunkId] + ".chunk.js";
};